import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import TeamUpdatesViewQuery, {
	type TeamUpdatesViewQuery as TeamUpdatesViewQueryType,
} from '../TeamUpdatesView/__generated__/TeamUpdatesViewQuery.graphql';

export const teamUpdatesResource = createRelayResource<TeamUpdatesViewQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const teamId = routerContext?.match?.params.id ?? '';
		return {
			query: TeamUpdatesViewQuery,
			variables: {
				teamId: teamId,
				workspaceUUID: context.workspace?.UUID || '',
				cloudId: context.workspace?.cloudId,
				shouldFetchUpdatesTabData: !fg('goal_types_m3_bundled_updates'),
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
